/* unplugin-vue-components disabled */import { render } from "./divider.vue?vue&type=template&id=2eb70899&scoped=true"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"

import "./divider.vue?vue&type=style&index=0&id=2eb70899&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb70899"],['__file',"src/controls/divider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2eb70899"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2eb70899', __exports__)) {
    api.reload('2eb70899', __exports__)
  }
  
  module.hot.accept("./divider.vue?vue&type=template&id=2eb70899&scoped=true", () => {
    api.rerender('2eb70899', render)
  })

}


export default __exports__